// src/components/dashboard/WalletBalance/WalletBalance.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCurrency } from '../../../context/CurrencyContext';
import './WalletBalance.css';

const WalletBalance = ({ balance, availableBalance, currency: walletCurrency, onDeposit, onWithdraw }) => {
  const navigate = useNavigate();
  const { currency: contextCurrency } = useCurrency();
  
  // Use currency from props (API response) if available, otherwise fall back to context
  const displayCurrency = walletCurrency || contextCurrency;

  const formatCurrency = (amount) => {
    const numAmount = parseFloat(amount) || 0;
    
    if (displayCurrency === 'NGN') {
      return new Intl.NumberFormat('en-NG', {
        style: 'currency',
        currency: 'NGN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(numAmount);
    } else {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(numAmount);
    }
  };

  console.log('💰 WalletBalance received:', { 
    balance, 
    availableBalance, 
    walletCurrency, 
    contextCurrency,
    displayCurrency 
  });

  return (
    <div className="wallet-balance">
      <div className="wallet-header">
        <h2>Wallet Balance</h2>
        <button 
          className="history-link" 
          onClick={() => navigate('/transaction-history')}
        >
          History
        </button>
      </div>
      
      {/* Large balance display */}
      <div className="wallet-main-balance">
        {formatCurrency(balance)}
      </div>
      
      <div className="wallet-actions">
        <button 
          className="wallet-btn deposit-btn"
          onClick={onDeposit}
        >
          Add Funds
        </button>
        <button 
          className="wallet-btn withdraw-btn"
          onClick={onWithdraw}
        >
          Withdraw
        </button>
      </div>

      {availableBalance !== undefined && (
        <div className="wallet-details">
          <div className="wallet-detail">
            <span>Available Balance:</span>
            <span className="amount">{formatCurrency(availableBalance)}</span>
          </div>
          {availableBalance !== balance && (
            <div className="wallet-detail">
              <span>Reserved:</span>
              <span className="amount reserved">
                {formatCurrency(balance - availableBalance)}
              </span>
            </div>
          )}
          <div className="wallet-detail currency-note">
            <small>Displaying in {displayCurrency}</small>
          </div>
        </div>
      )}
    </div>
  );
};

export default WalletBalance;